// extracted by mini-css-extract-plugin
export default {"group_item":"GroupItem_group_item__cIGRs","img_ani":"GroupItem_img_ani__LOsWO","mouseIn":"GroupItem_mouseIn__MY2NR"};